<div class="container_dialog">
    <div class="header_popup header_popup_center">
      <div class="title_popup title_popup_center">
        <span>{{"companies.invoicing"|translate}}</span>
      </div>
      <button (click)="closed()">
        <mat-icon style="color: black;">close</mat-icon>
      </button>
    </div>
    <form class="display_form" [formGroup]="form">
      <div class="input_field">
        <label for="payment_terms">{{ "companies.payment_terms" | translate }}</label>
        <select id="payment_terms" formControlName="payment_terms">
          <option selected disabled value="">{{ "companies.payment_terms" | translate }}</option>
          <option *ngFor="let paymentTerm of data.paymentTerms" [value]="paymentTerm.id">
            {{ paymentTerm.name  | translate}}
          </option>
        </select>
        <span class="error_ms" *ngIf="form.get('payment_terms')?.touched && form.get('payment_terms')?.errors">
          {{ "common.required_field" | translate }}
        </span>
      </div>
      <div class="input_field">
        <label for="currency">{{ "Catalogs.currency" | translate }}</label>
        <select id="currency" formControlName="currency">
          <option selected disabled value="">{{ "Catalogs.currency" | translate }}</option>
          <option *ngFor="let currency of data.currencies" [value]="currency.id">
            {{ currency.name }}
          </option>
        </select>
        <span class="error_ms" *ngIf="form.get('currency')?.touched && form.get('currency')?.errors">
          {{ "common.required_field" | translate }}
        </span>
      </div>
      <div class="midel_title">
        {{ "companies.taxe" | translate }}
      </div>
      <div class="input_field">
        <label for="tax_id">{{ "companies.tax_id" | translate }}</label>
        <input
          type="text"
          id="tax_id"
          placeholder="{{ 'companies.tax_id' | translate }}"
          formControlName="tax_id"
        />
      </div>
      <div class="input_field">
        <label for="tax">{{ "companies.taxe" | translate }}</label>
        <select id="tax" formControlName="tax">
          <option selected disabled value="">{{ "companies.taxe" | translate }}</option>
          <option value="0">0%</option>
          <option value="2.1">2,1%</option>
          <option value="4">4%</option>
          <option value="5.5">5,5%</option>
          <option value="10">10%</option>
          <option value="20">20%</option>
          <option value="22">22%</option>
        </select>
        <span class="error_ms" *ngIf="form.get('tax')?.touched && form.get('tax')?.errors">
          {{ "common.required_field" | translate }}
        </span>
      </div>
    </form>
    
    <div class="submet_btns">
      <button class="save_btn_pop_up cancel_btn_pop_up" (click)="closed()">
        <span>{{"common.back"|translate | uppercase}}</span>
        <img src="../../../../../assets/icones/arrow_back.svg" alt="">
      </button>
      <button class="save_btn_pop_up blue_btn" (click)="save()">
        <span> {{"common.save"|translate | uppercase}} </span>
        <img alt="" src="../../../../../assets/icones/arrow_circle_right.svg">
      </button>
    </div>
  </div>
